import type { EditorState, Transaction } from 'prosemirror-state';
import { NodeSelection } from 'prosemirror-state';
import type { Subject } from 'rxjs';

export const nodeTypeSelectionObserver =
  (subject$: Subject<number | null>, nodeTypeName: string) =>
  (transactions: readonly Transaction[], oldState: EditorState, newState: EditorState) => {
    if (oldState.selection.eq(newState.selection)) return null;

    if (newState.selection instanceof NodeSelection) {
      const { node } = newState.selection;
      if (node.type.name === nodeTypeName) {
        subject$.next(newState.selection.from);
      } else {
        subject$.next(null);
      }
    } else {
      subject$.next(null);
    }
    return null;
  };
